import { createTRPCContext } from '@trpc/tanstack-react-query';
import type { AppRouter } from '@backend/routers';
import { inferRouterOutputs } from '@trpc/server';

export type RouterOutputs = inferRouterOutputs<AppRouter>;
export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();
